import React from 'react';
import classNames from 'classnames';

export default ({
	title,
	subtitle,
	description,
	columns,
}) => (
	<div className="mt6 mb6 mt12--md mb12--md">
		<div className="grid-container contained">
			<div 
				className={classNames('row', {
					'mb3 mb5--md': !(subtitle || description),
					'mb3 mb8--md': (subtitle || description),
				})}>
				<div
					className={classNames('col', {
						'c6--md c4--lg': (subtitle || description),
						'c12': !(subtitle || description),
					})}>
					<h2 className="domaine--large">
						{title}
					</h2>
				</div>
				{(subtitle || description) && (
					<div className="col c6--md c7--lg">
						<h2 className="domaine--medium mb2">
							{subtitle}
						</h2>
						<p className="color--gray-text">
							{description}
						</p>
					</div>
				)}
			</div>

			<div className="row">
				{columns && columns.map(column => (
					<div
						className="col c6--md c4--lg mb5"
						key={column._key}>
						<h3 className="sans--small uppercase fw--600 mb2">
							{column.title}
						</h3>
						<hr className="mb2" />
						
						{column.features && column.features.map(feature => (
							<p
								key={feature._key}
								className="mb2">
								{feature.title} <br/>
								<span className="color--gray-text">
									{feature.description}
								</span>
							</p>
						))}
					</div>
				))}
			</div>
		</div>
	</div>
);